import React from 'react';
import {usePromiseTracker} from "react-promise-tracker";
import DommusLoading from './DommusLoading';

function DommusPromiseLoading(props){
	const {promiseInProgress} = usePromiseTracker();
	return promiseInProgress && <DommusLoading/>;
}

export default DommusPromiseLoading;